!(function () {
  'use strict';

  class CartBarUpsell extends HTMLElement {
    constructor() {
      super();
      this.boundSetHeight = this.setHeight.bind(this);
      this.intersectionObserver = null;
      this.mutationObserver = null;
      this.bundleWidgetSelector = '#svelte-bundle-widget';
    }

    connectedCallback() {
      this.setHeight();
      this.addEventListener('click', this.handleClick.bind(this));
      document.addEventListener('theme:resize', this.boundSetHeight);
      this.observeBundleWidget();
    }

    disconnectedCallback() {
      if (this.intersectionObserver) this.intersectionObserver.disconnect();
      if (this.mutationObserver) this.mutationObserver.disconnect();
      document.removeEventListener('theme:resize', this.boundSetHeight);
    }

    observeBundleWidget() {
      if (typeof IntersectionObserver === 'undefined') return;

      const target = document.querySelector(this.bundleWidgetSelector);
      if (target) {
        this.attachIntersectionObserver(target);
        return;
      }

      if (typeof MutationObserver === 'undefined') return;
      this.mutationObserver = new MutationObserver(() => {
        const node = document.querySelector(this.bundleWidgetSelector);
        if (!node) return;
        this.mutationObserver.disconnect();
        this.mutationObserver = null;
        this.attachIntersectionObserver(node);
      });
      this.mutationObserver.observe(document.body, { childList: true, subtree: true });
    }

    attachIntersectionObserver(target) {
      this.intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.classList.toggle('is-visible', !entry.isIntersecting);
        });
      });
      this.intersectionObserver.observe(target);
    }

    handleClick(event) {
      const button = event.target.closest('[data-cart-bar-upsell-add]');
      if (!button) return;
      event.preventDefault();
      if (button.hasAttribute('disabled')) return;
      this.addToCart(button);
    }

    addToCart(button) {
      const variantId = this.dataset.variantId;
      const quantity = parseInt(this.dataset.quantity || '2', 10);
      if (!variantId) return;

      button.classList.add('is-loading');
      button.setAttribute('disabled', 'disabled');

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);

      fetch(theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript',
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          button.classList.remove('is-loading');

          if (data.status) {
            button.removeAttribute('disabled');
            document.dispatchEvent(
              new CustomEvent('theme:product:add-error', {
                bubbles: true,
                detail: { message: data.message, description: data.description, holder: button },
              })
            );
            return;
          }

          button.classList.add('is-added');
          button.dispatchEvent(
            new CustomEvent('theme:product:add', {
              bubbles: true,
              detail: { response: data, button: button },
            })
          );
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));

          setTimeout(() => {
            button.classList.remove('is-added');
            button.removeAttribute('disabled');
          }, 2000);
        })
        .catch((error) => {
          console.error('CartBarUpsell add error:', error);
          button.classList.remove('is-loading');
          button.removeAttribute('disabled');
        });
    }

    setHeight() {
      document.documentElement.style.setProperty('--cart-bar-height', `${this.offsetHeight}px`);
    }
  }

  if (!customElements.get('cart-bar-upsell')) {
    customElements.define('cart-bar-upsell', CartBarUpsell);
  }
})();
